<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="error">
        <span class="headline white--text">Gästeliste löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du die Gästeliste "{{group.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="remove()" :loading="loading">Löschen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgGroupDelete',
    props: ['group'],
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    methods: {
      ...mapActions({
        removeGroup: 'admin/groups/remove',
        readAll: 'admin/groups/read',
      }),
      remove() {
        this.loading = true;
        this.removeGroup(this.group).then((res) => {
          this.loading = false;
          if (res) {
            this.readAll();
            this.dialog = false;
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
